var _path, _circle, _circle2, _circle3, _path2, _path3, _path4, _rect, _rect2, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 72,
    viewBox: "0 0 64 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99976 5C6.99976 2.23857 9.23833 0 11.9998 0H58.9998C61.7612 0 63.9998 2.23858 63.9998 5V67C63.9998 69.7614 61.7612 72 58.9998 72H11.9998C9.23833 72 6.99976 69.7614 6.99976 67V5Z",
    fill: "#FFEADB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 13.5,
    r: 3.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 36.5,
    r: 3.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 59.5,
    r: 3.5,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.896 38.2847C51.8948 38.2859 51.8935 38.2873 51.8922 38.2885V38.279L50.4377 39.7238C48.5567 41.6285 45.8173 42.4122 43.2135 41.7906C40.5902 41.0884 38.0964 39.9707 35.8266 38.4799C33.7179 37.1322 31.7637 35.5568 29.9994 33.7817C28.3761 32.1703 26.9177 30.4009 25.6457 28.4999C24.2543 26.4544 23.1531 24.2261 22.3732 21.8785C21.4792 19.1205 22.2201 16.0942 24.287 14.061L25.9901 12.3579C26.4637 11.8822 27.2331 11.8805 27.7087 12.354C27.7099 12.3553 27.7112 12.3565 27.7125 12.3579L33.0899 17.7353C33.5656 18.2089 33.5673 18.9783 33.0938 19.4538C33.0925 19.4551 33.0913 19.4563 33.0899 19.4577L29.9323 22.6153C29.0263 23.5114 28.9124 24.9355 29.6644 25.9643C30.8065 27.5317 32.0703 29.0065 33.4441 30.3754C34.9756 31.9136 36.6407 33.3129 38.4196 34.5569C39.4475 35.2739 40.8411 35.153 41.7303 34.2698L44.7826 31.1696C45.2562 30.694 46.0256 30.6923 46.5012 31.1658C46.5024 31.1671 46.5036 31.1683 46.505 31.1696L51.8921 36.5663C52.3678 37.0397 52.3695 37.809 51.896 38.2847Z",
    fill: "#EF7C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 53C21 51.8954 21.8954 51 23 51H49C50.1046 51 51 51.8954 51 53C51 54.1046 50.1046 55 49 55H23C21.8954 55 21 54.1046 21 53Z",
    fill: "#EF7C00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 61C26 59.8954 26.8954 59 28 59H44C45.1046 59 46 59.8954 46 61C46 62.1046 45.1046 63 44 63H28C26.8954 63 26 62.1046 26 61Z",
    fill: "#EF7C00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 57,
    width: 14,
    height: 5,
    rx: 2.5,
    fill: "#EF7C00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 34,
    width: 14,
    height: 5,
    rx: 2.5,
    fill: "#EF7C00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.5C0 12.1193 1.11929 11 2.5 11H11.5C12.8807 11 14 12.1193 14 13.5C14 14.8807 12.8807 16 11.5 16H2.5C1.11929 16 0 14.8807 0 13.5Z",
    fill: "#EF7C00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.5C0 12.1193 1.11929 11 2.5 11H7V16H2.5C1.11929 16 0 14.8807 0 13.5Z",
    fill: "#FF9D5A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 36.5C0 35.1193 1.11929 34 2.5 34H7V39H2.5C1.11929 39 0 37.8807 0 36.5Z",
    fill: "#FF9D5A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 59.5C0 58.1193 1.11929 57 2.5 57H7V62H2.5C1.11929 62 0 60.8807 0 59.5Z",
    fill: "#FF9D5A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPhone);
export default __webpack_public_path__ + "static/media/imgPhone.6e3384a9aab2c8376c747154624ce193.svg";
export { ForwardRef as ReactComponent };